import {
  faCheck,
  faEraser,
  faPenToSquare,
  faPlus,
  faRectangleXmark,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import BackButton from "../common/backButton";
import Footer from "../common/components/Footer";
import consts from "../consts";

function Usuarios() {
  const [usuarioFiltrado, setUsuarioFiltrado] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [values, setValues] = useState({});
  const navigate = useNavigate();

  const searchUsuarios = async () => {
    try {
      const resp = await axios.get(`${consts.API_URL}/usuarios`);
      const filtrados = resp.data.filter(
        (user) => user.status === 200 || user.status === 1
      );
      setUsuarios(filtrados);
    } catch (error) {
      console.log("Erro ao buscar usuários:", error);
    }
  };

  useEffect(() => {
    searchUsuarios();
  }, []);

  const verificaStatus = (status) => {
    if (status === 200) {
      status = "Administrador";
    } else if (status === 1) {
      status = "Usuário";
    } else {
      status = "Desativado";
    }
    return status;
  };

  const handleUpdateUsuario = (data) => {
    axios
      .put(`${consts.API_URL}/usuarios/${data.id}`, data)
      .then(() => {
        toast.success("Dados atualizados com sucesso!");
        setEditingUserId(null);
        setValues({});
        searchUsuarios();
      })
      .catch((error) => {
        console.log(`Erro ao atualizar usuário: ${error}`);
        toast.error("Não foi possível atualizar estes dados.");
      });
  };

  const changeValues = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleDeleteUsuario = (id) => {
    axios
      .post(`${consts.API_URL}/usuarios/${id}`)
      .then(() => {
        toast.success("Usuário excluído com sucesso!");
        searchUsuarios();
      })
      .catch((error) => {
        console.log(`Erro ao excluir usuário: ${error}`);
        toast.error("Não foi possível excluir estes usuário.");
      });
  };

  return (
    <div className="min-h-screen dark:bg-[#121212] dark:text-white">
      <div className="container h-full mx-auto">
        <div className="flex">
          <BackButton path="home" text="Voltar" />
        </div>
        <div className="flex">
          <span className="text-4xl font-bold mt-3">Usuários</span>
        </div>
        <div className="flex justify-between gap-1 mt-5">
          <div className="flex flex-col gap-1">
            <span className="text-sm">Pesquisar</span>
            <div className="flex gap-2">
              <input
                type="text"
                className="p-3 border border-gray-300 rounded-md outline-none dark:text-black w-96"
                value={usuarioFiltrado}
                onChange={(e) => setUsuarioFiltrado(e.target.value)}
                placeholder="&#128269; Digite sua pesquisa"
              />
              {usuarioFiltrado.length >= 1 && (
                <Tooltip title="Limpar">
                  <button
                    className="px-4 py-2 bg-gray-100 rounded-md hover:bg-gray-300 dark:text-black"
                    onClick={() => setUsuarioFiltrado("")}
                  >
                    <FontAwesomeIcon icon={faEraser} size={"lg"} />
                  </button>
                </Tooltip>
              )}
            </div>

            <button
              className="px-4 py-2 font-semibold text-center text-black bg-[#53D769] rounded-lg hover:bg-[#46C263] mt-5 w-[200px]"
              onClick={() => navigate(`/createUser`)}
            >
              <FontAwesomeIcon icon={faPlus} size="lg" className="w-5 h-5" />{" "}
              Cadastrar
            </button>
          </div>
        </div>

        <div className="grid justify-between grid-cols-[1fr_1.5fr_1fr_0.5fr] p-4 mt-5 text-center font-bold dark:bg-slate-700">
          <span>Nome</span>
          <span>E-mail</span>
          <span>Status</span>
          <span>Ações</span>
        </div>

        <div className="flex flex-wrap">
          {usuarios
            .filter((val) => {
              if (usuarioFiltrado === "") return true;

              const filtro = usuarioFiltrado.toLowerCase();

              return (
                val.name?.toLowerCase().includes(filtro) ||
                verificaStatus(val.status)?.toLowerCase().includes(filtro) ||
                val.email?.toLowerCase().includes(filtro)
              );
            })
            .map((item) => {
              const isEditing = editingUserId === item.id;

              return (
                <div
                  key={item.id}
                  className="grid w-full grid-cols-[1fr_1.5fr_1fr_0.5fr] p-2 gap-1 dark:bg-slate-800 items-center font-medium bg-blue-50 mb-3 rounded-xl"
                  id={item.id}
                >
                  {isEditing ? (
                    <>
                      <input
                        type="text"
                        name="name"
                        onChange={changeValues}
                        value={values.name}
                        className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                      />
                      <input
                        type="text"
                        name="email"
                        onChange={changeValues}
                        value={values.email}
                        className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                      />
                      <select
                        name="status"
                        onChange={changeValues}
                        value={values.tipo}
                        className="p-2 border-2 border-gray-200 rounded-lg bg-white text-center"
                      >
                        <option value="">Selecione uma opção</option>
                        <option value="1">Usuário</option>
                        <option value="200">Administrador</option>
                      </select>
                      <div className="flex gap-2 justify-center p-2">
                        <Tooltip title="Confirmar">
                          <button
                            onClick={() => handleUpdateUsuario(values)}
                            className="px-4 py-2 bg-[#41A700] rounded-md hover:bg-[#308941]"
                          >
                            <FontAwesomeIcon icon={faCheck} size="lg" />
                          </button>
                        </Tooltip>
                        <Tooltip title="Cancelar">
                          <button
                            onClick={() => setEditingUserId(null)}
                            className="px-4 py-2 bg-[#999999] rounded-md text-white"
                          >
                            <FontAwesomeIcon
                              icon={faRectangleXmark}
                              size="lg"
                            />
                          </button>
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    <>
                      <span className="border-2 border-gray-200 rounded-lg bg-white text-center p-2">
                        {item.name}
                      </span>
                      <span className="bg-white text-center border-gray-200 border-2 rounded-lg p-2">
                        {item.email}
                      </span>
                      <span className="bg-white text-center border-gray-200 border-2 rounded-lg p-2">
                        {verificaStatus(item.status)}
                      </span>
                      <div className="flex gap-2 justify-center p-2">
                        <Tooltip title="Editar">
                          <button
                            onClick={() => {
                              setEditingUserId(item.id);
                              setValues({
                                id: item.id,
                                name: item.name,
                                email: item.email,
                                status: item.status,
                              });
                            }}
                            className="px-4 py-2 bg-[#CCCCCC] rounded-md hover:bg-[#999999] text-black"
                          >
                            <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                          </button>
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <button
                            className="px-4 py-2 bg-[#FC3D39] rounded-md hover:bg-[#999999] text-white cursor-pointer"
                            onClick={() => handleDeleteUsuario(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrashCan} size="lg" />
                          </button>
                        </Tooltip>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Usuarios;
